import axios from 'axios';
import { GET_RESERVATIONS, GET_RESERVATION_SUGGESTED_SEATS, GET_RESERVATIONBYID } from '../types';
import { setAlert } from './alert';

export const getReservations = () => async dispatch => {
  const url = `${process.env.REACT_APP_BE_URL}/reservation/`;

  await axios.get(url)
  .then((res)=>{
    dispatch({ type: GET_RESERVATIONS, payload: res.data });
  })
  .catch((error)=>{
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check43', 'error', 5000));
  })
}

export const getReservationById = (id,ShowId) => async dispatch => {
  const url = `${process.env.REACT_APP_BE_URL}/reservation/${id}/${ShowId}`;
  axios.get(url)
  .then((res)=>{
    dispatch({ type: GET_RESERVATIONBYID, payload: res.data.data });
  })
  .catch((error)=>{
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check42', 'error', 5000));
  })
}

export const getSuggestedReservationSeats = username => async dispatch => {
  try {
    const token = localStorage.getItem('jwtToken');
    const url = '/reservations/usermodeling/' + username;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const reservationSeats = await response.json();
    if (response.ok) {
      dispatch({
        type: GET_RESERVATION_SUGGESTED_SEATS,
        payload: reservationSeats
      });
    }
  } catch (error) {
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check41', 'error', 5000));
  }
};

export const addReservation = reservation => async dispatch => {
  try {
    const token = localStorage.getItem('jwtToken');
    const url = '/reservations';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reservation)
    });
    if (response.ok) {
      const { reservation, QRCode } = await response.json();
      dispatch(setAlert('Reservation Created', 'success', 5000));
      return {
        status: 'success',
        message: 'Reservation Created',
        data: { reservation, QRCode }
      };
    }
  } catch (error) {
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check40', 'error', 5000));
    return {
      status: 'error',
      message: ' Reservation have not been created, try again.'
    };
  }
};

export const updateReservation = (reservation, id) => async dispatch => {
  try {
    const token = localStorage.getItem('jwtToken');
    const url = '/reservations/' + id;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reservation)
    });
    if (response.ok) {
      dispatch(setAlert('Reservation Updated', 'success', 5000));
      return { status: 'success', message: 'Reservation Updated' };
    }
  } catch (error) {
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check39', 'error', 5000));
    return {
      status: 'error',
      message: ' Reservation have not been updated, try again.'
    };
  }
};

export const removeReservation = id => async dispatch => {
  try {
    const token = localStorage.getItem('jwtToken');
    const url = '/reservations/' + id;
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      dispatch(setAlert('Reservation Deleted', 'success', 5000));
      return { status: 'success', message: 'Reservation Removed' };
    }
  } catch (error) {
    dispatch(setAlert(error?.response?.data?.error?.message|| 'check38', 'error', 5000));
    return {
      status: 'error',
      message: ' Reservation have not been deleted, try again.'
    };
  }
};
